type GetDateFormatStringProps = {
  lang?: string;
  separator?: string;
};

export const getDateFormatString = (props?: GetDateFormatStringProps): string => {
  const {lang = `en-US`, separator = ``} = props || {};
  const formatObj = new Intl.DateTimeFormat(lang).formatToParts(new Date());

  return formatObj
    .map(obj => {
      switch (obj.type) {
        case `day`:
          return `d`;
        case `month`:
          return `M`;
        case `year`:
          return `yy`;
        default:
          return obj.value;
      }
    })
    .join(separator);
};
